
const DOMAIN = "https://peaccollaboration.com";

export {DOMAIN};
